import { useEffect } from "react";
import JobService from "../Service.js/jobService";
import { useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import cartIcon from "../Assets/Icons/cart.svg";
import { TbCurrencyRupee } from "react-icons/tb";
import { TfiLocationPin } from "react-icons/tfi";
import { TiLocationArrowOutline } from "react-icons/ti";
import { LuGraduationCap } from "react-icons/lu";
import { MdOutlineWorkOutline } from "react-icons/md";
import { Button as AntdButton, Button, Tooltip } from "antd";
import Header from "./Header";
import toast from "react-hot-toast";
import bgIcon from "../Assets/Icons/ff2.svg";
import FooterLayout from "../Components/FooterLayout";
import { Link } from "react-router-dom";
import tickIcon from "../Assets/Icons/tick.svg";
import CandidateLogin from "./CandidateLogin";
import { IoArrowBackSharp, IoTimeOutline } from "react-icons/io5";
import { CgCalendarDates } from "react-icons/cg";
import cartIcon2 from "../Assets/Icons/cart2.svg";
import { HiOutlineCalendarDays } from "react-icons/hi2";
import Empty from "../Components/CommonCommponents/Empty";
import recruiterIcon from "../Assets/Icons/Recruiter.png";
import { isEmpty } from "lodash";
import ViewJob from "./CandidateProfileDetails/Viewjob";

const JobDetails = () => {
  const { jobId, publish_share } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const publishShare = queryParams.get("publish_share");
  console.log("isPublish", publishShare);
  const [open, setOpen] = useState(false);
  const [jobInfoData, setjobInfoData] = useState();
  const [suggestedJobDetails, setSuggestedJobDetails] = useState();
  const currentUser = localStorage.getItem("candidate");

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const jobDetails = async () => {
    await JobService.getJobInfo(jobId)
      .then(
        (response) => {
          setjobInfoData(response.data.data);
          //setStatus(response.data.data.applied);
        },
        (error) => {
          console.log(error);
        },
      )
      .catch((error) => {
        console.log(error);
      });
  };
  const getSuggestedJobDetails = async () => {
    await JobService.getSuggestedJobs(jobId)
      .then(
        (response) => {
          setSuggestedJobDetails(response.data.data);
        },
        (error) => {
          console.log(error);
        },
      )
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (jobId) {
      jobDetails();
      getSuggestedJobDetails();
    }
  }, []);
  const handleClick = async (id) => {
    await JobService.getJobInfo(id)
      .then(
        (response) => {
          setjobInfoData(response.data.data);
          //setStatus(response.data.data.applied);
        },
        (error) => {
          console.log(error);
        },
      )
      .catch((error) => {
        console.log(error);
      });
  };
  const deleteCart = async (jobId) => {
    await JobService.deleteCart(jobId)
      .then((response) => {
        toast.success("Removed from BookMark");
        jobDetails();
      })
      .catch((error) => {
        toast.error("Failed To Add");
      });
  };
  const handleCart = async (jobId) => {
    await JobService.addToCart(jobId)
      .then((response) => {
        toast.success("Added To BookMark");
        jobDetails();
      })
      .catch((error) => {
        toast.error("Failed To Add");
      });
  };
  const handleApply = async () => {
    await JobService.applyForJob(jobId)
      .then((response) => {
        if (response.data.success == true) {
          toast.success("Sucessfully Applied For the job");
          jobDetails();
        }
      })
      .catch((error) => {
        console.log("response", error?.response?.data?.error_info.job);
        console.log("response", error.response.data.error_info.job[0]);
        if (error.response.data.error_info) {
          toast.error(error.response.data.error_info.job[0]);
        } else {
          toast.error("Failed to apply");
        }
      });
  };
  const handleLogin = () => {
    navigate("/login");
  };
  const noDataMessage = "Not Mentioned";
  const locations = jobInfoData?.locations?.map((obj) => obj);
  const educations = jobInfoData?.education_details?.map((obj) => obj);
  const Languages = jobInfoData?.languages_preferred.map((obj) => obj);
  const certification = jobInfoData?.certification.map((obj) => obj);
  const nationality = jobInfoData?.nationality.map((obj) => obj);
  return (
    <>
      {/* <MetaTags>
        <title>{jobInfoData?.title || "Job Details"}</title>
        <meta name="description" content="test Yvi" />
        <meta property="og:title" content={jobInfoData?.title} />
        <meta property="og:image" content="path/to/image.jpg" />
      </MetaTags> */}
      {/* <Helmet>
        <title>{jobInfoData?.title || "Job Details"}</title>
        <meta
          name="description"
          content={jobInfoData?.description || "Description of the job"}
        /> */}
      {/* <meta property="og:title" content={jobInfoData?.title} />
        <meta
          property="og:description"
          content="Apply for Nursing Superintendent "
        /> */}
      {/* <meta property="og:url" content={jobUrl} />
        <meta property="og:type" content="article" />
        <meta property="og:image" content={jobImageUrl} />
        <meta property="og:image:secure_url" content={jobImageUrl} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="687" />
        <meta name="description" content={jobDescription} />
        <meta property="og:description" content={jobDescription} /> */}
      {/* </Helmet> */}
      <div className="w-full pageContent scrollbar-hide ">
        <p
          className="flex items-center gap-2 justify-start cursor-pointer font-medium pr-8"
          onClick={() => navigate(-1)}
        >
          <IoArrowBackSharp />
          Back
        </p>
        <div className="">
          {jobInfoData && (
            <div className="mt-12 chart_div">
              <div className="flex-col w-full lg:w-3/4 lg:flex lg:flex-row ">
                <div className="w-full lg:w-5/6 sm:px-8 xs:px-8">
                  <div className="rounded-xl border border-gray-300 p-3 md:ml-0 bg-[#FFF]">
                    <div
                      className="rounded-xl"
                      style={{ backgroundColor: "#FFF" }}
                    >
                      <div className="flex items-center justify-between">
                        <div className="px-6 pt-4">
                          <p className="text-base font-semibold">
                            {jobInfoData?.title}
                          </p>
                        </div>
                        <div className="flex flex-row flex-wrap justify-between px-6 ">
                          {currentUser ? (
                            jobInfoData.is_saved === false ? (
                              <div className="pt-2">
                                <Tooltip placement="bottom" title="save job">
                                  <button>
                                    <img
                                      alt="cart"
                                      src={cartIcon}
                                      onClick={() => handleCart(jobInfoData.id)}
                                    />
                                  </button>
                                </Tooltip>
                              </div>
                            ) : (
                              <div className="pt-2">
                                <Tooltip placement="bottom" title="saved job">
                                  <button>
                                    <img
                                      alt="cart"
                                      className=""
                                      src={cartIcon2}
                                      onClick={() => deleteCart(jobInfoData.id)}
                                    />
                                  </button>
                                </Tooltip>
                              </div>
                            )
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="px-6 pt-4">
                        <p className="text-base font-semibold">
                          {jobInfoData?.client_name}
                        </p>
                      </div>

                      <div className="px-6 mt-4">
                        {/* <p className="text-base font-semibold">{jobInfoData?.title}</p> */}
                      </div>

                      <div className="px-6 mt-0">
                        <ul className="flex flex-wrap">
                          <li className="md:mb-4">
                            <div className="flex flex-wrap">
                              {jobInfoData.experience != false && (
                                <span className="flex flex-wrap items-center mr-4">
                                  <MdOutlineWorkOutline className="mr-2" />
                                  {jobInfoData.experience}
                                </span>
                              )}
                              {jobInfoData.experience != false &&
                                (jobInfoData.salary_details != false ||
                                  jobInfoData.salary_confidential != false) && (
                                  <span className="hidden mx-3 divider sm:inline-block">
                                    |
                                  </span>
                                )}
                              {jobInfoData.salary_confidential === true ? (
                                <span className="flex items-center ">
                                  <TbCurrencyRupee className="mr-2 contentIcon" />
                                  <p>As per industry standards </p>
                                </span>
                              ) : (
                                jobInfoData.salary_details != false && (
                                  <span className="flex items-center">
                                    <TbCurrencyRupee className="mr-2 contentIcon" />
                                    {jobInfoData.salary_details}
                                  </span>
                                )
                              )}
                              {(jobInfoData.salary_details != false ||
                                jobInfoData.salary_confidential != false) &&
                                jobInfoData.job_type && (
                                  <span className="hidden mx-3 divider sm:inline-block">
                                    |
                                  </span>
                                )}
                              {jobInfoData.experience != false &&
                                jobInfoData.job_type &&
                                jobInfoData.salary_details == false &&
                                jobInfoData.salary_confidential == false && (
                                  <span className="hidden mx-4 divider sm:inline-block">
                                    |
                                  </span>
                                )}
                              {jobInfoData.job_type && (
                                <span className="flex items-center mr-4 md:ml-2">
                                  <TiLocationArrowOutline className="mr-2 contentIcon" />
                                  {jobInfoData.job_type || noDataMessage}
                                </span>
                              )}
                            </div>
                          </li>
                        </ul>
                        <ul className="flex flex-wrap ">
                          <li className=" xs:mb-0">
                            <div className="flex flex-wrap">
                              {jobInfoData?.education_details.length > 0 && (
                                <span className="flex flex-wrap items-center mb-4 mr-4">
                                  <LuGraduationCap className="mr-2" />
                                  {educations.join(",")}
                                </span>
                              )}
                              {jobInfoData?.education_details.length > 0 &&
                                jobInfoData?.locations.length > 0 && (
                                  <span className="hidden mx-3 divider sm:inline-block">
                                    |
                                  </span>
                                )}
                              {jobInfoData?.locations.length > 0 && (
                                <span className="flex flex-wrap items-center mb-4">
                                  <TfiLocationPin className="mr-2 contentIcon" />
                                  {locations.join(",")}
                                </span>
                              )}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="flex flex-row justify-between w-full mt-4 items-center px-6">
                      <div className="">
                        <div className="pt-1 mt-2">
                          <p>{jobInfoData?.posted}</p>
                        </div>
                      </div>
                      <div className="flex flex-wrap">
                        {/* <div className="px-4 pt-1 mt-2 ">
                        <p>
                          Job Closing Date :{" "}
                          {jobInfoData?.closure_period || noDataMessage}
                        </p>
                      </div>
                      <span className="hidden pt-1 mt-2 divider sm:inline-block">
                        |
                      </span> */}
                        <div className="px-4 pt-1 mt-2">
                          <p>
                            No of vacancies:{" "}
                            {jobInfoData?.number_of_openings || noDataMessage}
                          </p>
                        </div>
                      </div>

                      <div className="flex flex-wrap justify-end">
                        {jobInfoData?.current_status !== false && (
                          <div className="px-2">
                            <p className="px-2 pt-[5px] text-[#1C4980] text-base font-semibold">
                              {jobInfoData?.current_status}
                            </p>
                          </div>
                        )}

                        {currentUser === null ? (
                          <div>
                            <Button
                            className="rounded-full text-[#3E94EB] text-base font-semibold font-poppins border border-[#3E94EB]"
                            onClick={handleLogin}
                          >
                            Login To Apply
                          </Button>
                          </div>
                        ) : jobInfoData.applied === false ? (
                          <Button
                            className="rounded-full text-white bg-[#1C4980] text-base font-semibold "
                            onClick={handleApply}
                          >
                            Apply
                          </Button>
                        ) : (
                          <div className="flex px-5 py-1">
                            <p className="px-2 text-[#1C4980] text-base font-semibold">
                              Applied
                            </p>
                            <img
                              src={tickIcon}
                              alt="work"
                              className="w-4 h-auto contentIcon"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="mt-6 ">
                    <div className="rounded-xl border border-gray-300 p-10  bg-[#FFF]">
                      <p className="text-base font-semibold">Job description</p>
                      {/* <p className="mt-4">{jobInfoData.description || noDataMessage}</p> */}

                      <p
                        className="mt-4 htmlstyling"
                        dangerouslySetInnerHTML={{
                          __html: `${jobInfoData && jobInfoData.description}`,
                        }}
                      ></p>
                      {/* 
                      <div className="mt-8">
                        {jobInfoData && (
                          <ViewJob jobInfoData={jobInfoData} />
                        )}
                      </div> */}

                      {jobInfoData?.is_schedule_hidden && (
                        <div className="mt-8">
                          <ViewJob jobInfoData={jobInfoData} />
                        </div>
                      )}

                      {/* <div className="mt-4">
                                            <p className="text-base font-semibold">Education</p>
                                            <p className="mt-4">{educations.join(',')}</p>
                     
                     </div> */}
                      {jobInfoData?.required_skill?.length > 0 && (
                        <div className="mt-8">
                          <p className="text-base font-semibold">Key Skills</p>
                          <div className="flex flex-wrap mt-4">
                            {jobInfoData.required_skill?.map((item, index) => {
                              return (
                                <div className="p-1 mx-2 mt-4 border border-gray-400 rounded-3xl">
                                  <p className="px-2 pt-1 text-xs font-normal">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                      {jobInfoData.preferred_skill.length > 0 && (
                        <div className="mt-8">
                          <p className="text-base font-semibold">
                            Preferred Skill
                          </p>
                          <div className="flex flex-wrap mt-4">
                            {jobInfoData.preferred_skill?.map((item, index) => {
                              return (
                                <div className="p-1 mx-2 border border-gray-400 rounded-3xl">
                                  <p className="px-2 pt-1 text-xs font-normal">
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {currentUser &&
                 <div className="mt-4 lg:w-3/6 lg:pl-4 sm:sm:w-full sm:px-8 xs:px-8 lg:mt-0 ">
                  <div className="rounded-xl border border-gray-300 p-3 md:ml-0 bg-[#FFF] w-full min-h-[25%] overflow-y-auto">
                    <div className="px-4 mt-4">
                      {!isEmpty(suggestedJobDetails?.results) ? (
                        <div>
                          <p className="text-base font-semibold">
                            Jobs you might be interested in
                          </p>
                          <div className="w-full">
                            {suggestedJobDetails?.results?.map(
                              (item, index) => {
                                const colors = ["#ffffff"];
                                const noDataMessage = "Not Assigned";
                                const locations = item.locations?.map(
                                  (obj) => obj,
                                );
                                return (
                                  <div className="mt-6">
                                    <p className="text-xs text-[#5E4418]">
                                      {item?.posted}
                                    </p>

                                    <button
                                      className="pt-3 text-xl font-semibold"
                                      onClick={() => handleClick(item.id)}
                                    >
                                      {item?.title}
                                    </button>

                                    <p
                                      className="pt-4 htmlstyling line-clamp-3"
                                      dangerouslySetInnerHTML={{
                                        __html: `${item.description}`,
                                      }}
                                    ></p>
                                    <span className="flex flex-wrap items-center pt-4 mr-4">
                                      <MdOutlineWorkOutline className="mr-2" />
                                      {item.experience}
                                    </span>
                                    <span className="flex items-center pt-4 mr-4">
                                      <TiLocationArrowOutline className="mr-2 contentIcon" />
                                      {item.job_type || noDataMessage}
                                    </span>
                                    <div className="bg-[#E7E7E7] h-[1px] w-full mt-4"></div>
                                  </div>
                                );
                              },
                            )}
                          </div>
                        </div>
                      ) : (
                        <div className="px-8 pb-8">
                          <div className="flex items-center justify-center">
                            <Empty
                              description={
                                <>{<p> No job suggestion found</p>}</>
                              }
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* <div className="mt-6 mb-14">
                    <div
                      className="p-4 border border-gray-300 rounded-xl "
                      style={{
                        background:
                          "linear-gradient(90deg, rgba(203, 255, 239, 0.62) 0.9%, rgba(234, 255, 248, 0.62) 42.58%, rgba(239, 255, 250, 0.62) 75.1%, rgba(255, 255, 255, 0.62) 98.42%)",
                      }}
                    >
                      <div className="flex items-center justify-center">
                        <div>
                          <div className="">
                            <img src={recruiterIcon} alt="recruiterIcon" />
                          </div>
                          <div className="pt-6">
                            <p className="text-xl font-semibold">
                              The Resume to get your dream job{" "}
                            </p>
                            <p className="text-sm text-[#454545]">
                              Create an impressive resume in minutes
                            </p>
                          </div>
                          <div className="flex items-center justify-center pt-6 pb-10">
                            {currentUser === null ? (
                              <div className="flex justify-end">
                                <Button
                                  className="rounded-full text-white bg-[#1C4980] text-base font-semibold"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                >
                                  <Link to={`/login`}>
                                    Login To Build Your Resume
                                  </Link>
                                </Button>
                              </div>
                            ) : (
                              <Button className="rounded-full text-white bg-[#1C4980] text-base font-semibold">
                                <Link
                                  to={`/resume-templates/${jobInfoData.candidate_id}/${jobInfoData.user_id}`}
                                >
                                  Build Your Resume
                                </Link>
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
                }
               
              </div>
            </div>
          )}
        </div>
        {/* <div className="w-full mt-40">
          <img alt="icon" src={bgIcon} />
        </div> */}
        <div className="pt-40">{/* <FooterLayout /> */}</div>
      </div>
    </>
  );
};
export default JobDetails;
{
  /* {!publishShare && (
                  <div className="mt-6 ">
                    <div className="p-8 ml-10 border border-gray-300 rounded-xl md:ml-0">
                      <ul className="flex flex-wrap">
                        <li className="mb-4">
                          <div className="flex flex-wrap">
                            {jobInfoData.relevant_experience != false && (
                              <span className="flex flex-wrap items-center ">
                                Relevant Experience :
                                <p className="pl-2 text-base font-semibold">
                                  {jobInfoData.relevant_experience}
                                </p>
                              </span>
                            )}
                            {jobInfoData.notice_period != false &&
                              jobInfoData.relevant_experience != false && (
                                <span className="hidden mx-3 divider sm:inline-block">
                                  |
                                </span>
                              )}
                            {jobInfoData.notice_period != false && (
                              <span className="flex flex-wrap items-center">
                                Notice Period :
                                <p className="pl-2 text-base font-semibold">
                                  {jobInfoData.notice_period}
                                </p>
                              </span>
                            )}
                          </div>
                        </li>
                      </ul>
                      <ul className="flex flex-wrap">
                        <li className="mb-4">
                          <div className="flex flex-wrap">
                            <span className="flex flex-wrap items-center">
                              Gender Preferred :
                              <p className="pl-2 text-base font-semibold">
                                {jobInfoData.gender}
                              </p>
                            </span>
                            <span className="hidden mx-3 divider sm:inline-block">
                              |
                            </span>
                            <span className="flex flex-wrap items-center">
                              Driving License Required :
                              <p className="pl-2 text-base font-semibold">
                                {jobInfoData.driving_license_required ||
                                  noDataMessage}
                              </p>
                            </span>

                          </div>
                        </li>
                      </ul>
                      <ul className="flex flex-wrap">
                        <li className="mb-4">
                          <div className="flex flex-wrap">
                            <span className="flex flex-wrap items-center">
                              Internal Hire :
                              <p className="pl-2 text-base font-semibold">
                                {jobInfoData.internal_hire || noDataMessage}
                              </p>
                            </span>
                            <span className="hidden mx-3 divider sm:inline-block">
                              |
                            </span>
                            <span className="flex flex-wrap items-center ">
                              Reference Type :
                              <p className="pl-2 text-base font-semibold">
                                {jobInfoData.reference_type || noDataMessage}
                              </p>
                            </span>
                            <span className="hidden mx-3 divider sm:inline-block">
                              |
                            </span>
                            <span className="flex flex-wrap items-center mr-4">
                              Job Priority :
                              <p className="pl-2 text-base font-semibold">
                                {jobInfoData.priority || noDataMessage}
                              </p>
                            </span>
                          </div>
                        </li>
                      </ul>
                      <ul className="flex flex-wrap">
                        <li className="">
                          <div className="flex flex-wrap">
                            <span className="flex flex-wrap items-center mr-4">
                              Visa Required :
                              <p className="pl-2 text-base font-semibold">
                                {jobInfoData.visa_required || noDataMessage}
                              </p>
                            </span>
                     

                            <span className="hidden mx-3 divider sm:inline-block">
                              |
                            </span>
                            <span className="flex flex-wrap items-center mr-4">
                              Ready to Relocate :
                              <p className="pl-2 text-base font-semibold">
                                {jobInfoData.ready_to_relocate || noDataMessage}
                              </p>
                            </span>
                          </div>
                        </li>
                      </ul>
                      {jobInfoData.languages_preferred.length > 0 ||
                        (jobInfoData?.nationality.length > 0 && (
                          <ul className="flex flex-wrap">
                            <li className="mt-4">
                              <div className="flex flex-wrap">
                                {jobInfoData.languages_preferred.length > 0 && (
                                  <span className="flex items-center mr-4">
                                    Languages Preferred :
                                    <p className="pl-2 text-base font-semibold">
                                      {Languages.join(",")}
                                    </p>
                                  </span>
                                )}
                                {jobInfoData.languages_preferred.length > 0 &&
                                  jobInfoData?.nationality.length > 0 && (
                                    <span className="hidden mx-3 divider sm:inline-block">
                                      |
                                    </span>
                                  )}
                                {jobInfoData?.nationality.length > 0 && (
                                  <span className="flex flex-wrap items-center">
                                    Who Can Apply :
                                    <p className="pl-2 text-base font-semibold">
                                      {nationality.join(",") || noDataMessage}
                                    </p>
                                  </span>
                                )}
                              </div>
                            </li>
                          </ul>
                        ))}
                      {jobInfoData?.certification.length > 0 && (
                        <ul className="flex flex-wrap">
                          <li className="mt-4">
                            <div className="flex flex-wrap">
                              <span className="flex flex-wrap items-center">
                                Certification Required :
                                <p className="px-2 text-base font-semibold">
                                  {certification.join(",") || noDataMessage}
                                </p>
                              </span>
                            </div>
                          </li>
                        </ul>
                      )}
                      {jobInfoData.location_address != null && (
                        <ul className="flex flex-wrap">
                          <li className="mt-4">
                            <div className="flex flex-wrap">
                              <span className="flex items-center">
                                Address :
                                <p className="px-2 text-base font-semibold">
                                  {" "}
                                  {jobInfoData.location_address}
                                </p>
                              </span>
                            </div>
                          </li>
                        </ul>
                      )}
                      <div className="h-[1px] bg-[#DEDEDE] mt-6 mb-6"></div>
                      {jobInfoData.job_work_from_date &&
                        jobInfoData.job_work_end_date && (
                          <div>
                            <div className="mb-4">
                              <p className="text-base font-semibold">
                                Job Schedule
                              </p>
                            </div>
                            <ul className="flex flex-wrap">
                              <li className="mb-8">
                                <div className="flex flex-wrap">
                                  <span className="flex items-center mr-4">
                                    <TiLocationArrowOutline className="mr-2 contentIcon" />
                                    Job Type :{" "}
                                    {jobInfoData.job_type || noDataMessage}
                                  </span>
                                </div>
                              </li>
                            </ul>
                 
                            <div className="flex items-center gap-5">
                              <div>
                                <p className="flex flex-wrap items-center w-full">
                                  <HiOutlineCalendarDays className="mr-2 contentIcon" />
                                  Days
                                </p>
                                <p className="flex items-center w-full">
                                  {jobInfoData?.job_days &&
                                    jobInfoData?.job_days?.toString()}
                                </p>
                              </div>
                              <div>
                                <p className="flex flex-wrap items-center w-full">
                                  <CgCalendarDates className="mr-2 contentIcon" />
                                  Date
                                </p>
                                <p className="flex items-center w-full text-md">
                                  {jobInfoData.job_work_from_date} to &nbsp;
                                  {jobInfoData.job_work_end_date}
                                </p>
                              </div>
                              <div>
                                <p className="flex flex-wrap items-center w-full">
                                  <IoTimeOutline className="mr-2 contentIcon" />
                                  Time
                                </p>
                                <div>
                                  {jobInfoData?.job_work_timings
                                    ? jobInfoData?.job_work_timings?.map(
                                        (time) => (
                                          <p>
                                            {time?.work_from_time} to{" "}
                                            {time?.work_end_time}
                                          </p>
                                        )
                                      )
                                    : "-"}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                )} */
}
